<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList" />
    <div class="topTip">
      <span class="f18 col_black mr20">{{
        `${$route.query.planCode}批次${$route.query.courseName}`
      }}</span>
    </div>
    <div class="searchBox">
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="stuSelectParams"
        @search="getStuList"
      />
    </div>

    <div class="mainCon">
      <!-- 组件样式不符合, 单独配置该按钮 -->
      <div :class="[ isUse_SetErrorList ? 'batchOperation' : 'batchOperationDis']" v-if="batchOperBtn.length > 0">
        <ul>
          <li
            class="batchBtn"
            v-for="item in batchOperBtn"
            :key="item.title"
            @click="item.click()"
          >
            <a href="javascript:;">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- 优秀/及格/不及格 人数 -->
      <p class="col_blue mb10">{{totalText}}</p>
      <!-- 表格 -->
      <ots-table-group
        :tableHeader="tableHeader"
        :tableData="tableData"
        :tableOption="tableOption"
        @handleSelectionChange="bachOper"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group>
    </div>
    
    <!-- 批量设置异常 -->
    <ots-custom-dialog :dialog.sync="batchSetError" title="设置考试状态">
      <template v-slot:content>
        <div>
          <p class="studentNumber">为您所需选择的 <span class='col_red'>{{selectIds.length}}</span> 个学生设置！</p>
          <el-form inline label-width="80px">
            <div>
              <el-form-item label="考试状态">
                <el-select v-model="batchSignParams.examState" placeholder="请选择">
                  <el-option
                    v-for="item in examSignList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
                <p class="col_red mt15">设置后学生考试分数将置为0，请慎重操作！</p>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="batchSetError = false">取消</el-button>
        <el-button round type="primary" @click="batchSetSign">确定</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 单个处理异常弹窗 -->
    <ots-custom-dialog :dialog.sync="signDialog" title="设置考试状态">
      <template v-slot:content>
        <div>
          <el-form inline label-width="80px">
                <div>
                  <el-form-item label="姓名">
                    <span>{{currentStudent.realName}}</span>
                  </el-form-item>
                </div>
                <div>
                  <el-form-item label="证件号">
                    <span>{{currentStudent.cardNo}}</span>
                  </el-form-item>
                </div>
                <div>
                    <el-form-item label="考试状态">
                    <el-select v-model="signParams.checkState" placeholder="请选择">
                        <el-option
                            v-for="item in examSignList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <p class="col_red mt15">设置后学生考试分数将置为0，请慎重操作！</p>
                    </el-form-item>
                </div>
                <div>
                  
                </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="signDialog = false">取消</el-button>
        <el-button round type="primary" @click="setSign">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>
import {
  getStudentScoreListFn,
  getOtsUrlFn,
  changeExamCheckStateFn,
  exportStudentScoreFn,
  getPlanCoursePublishFn
} from "@/http/modules/examSet/score";

import { batchHumanAudit } from '@/http/modules/examSet/varAudit.js'
const photoState = {
  0: "未通过",
  1: "通过",
  2: "-",
};
export default {
  name: "currentScore",
  data() {
    return {
      signDialog: false,
      currentStudent: {},
      examSignList: [],
      totalText: '',
      planInfo: {},
      studentInfo: {},
      mainTopBtnList: [
          {
              title: '导出',
              fn: this.exportScore
          }
      ],
      selectList: [
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证/证件号",
          requestKey: "searchKey",
        },
        {
          title: "人脸验证状态",
          type: 'select',
          requestKey: 'systemAuditStatus',
          label: "name",
          value: "id",
          data: [
            {id: "", name: "全部"},
            {id: 1, name: "通过"},
            {id: 0, name: "未通过"}
          ],
        },
        {
          title: "人脸验证审核状态",
          type: "select",
          requestKey: "humanAuditState",
          label: "name",
          value: "id",
          data: [
            {id: "", name: "全部"},
            {id: 0, name: "待审核"},
            {id: 2, name: "审核通过"},
            {id: 1, name: "审核不通过"},
          ]
        }
      ],
      
      /* *** 查询考生成绩表单参数 *** */
      stuSelectParams: {
        searchKey: "",
        systemAuditStatus: "",
        humanAuditState: "",
      },
      /* *** 批量设置异常 *** */
      batchSignParams: {
        examState: "",
        planId: "",
        studentCourseIds: "",
      },
      signParams: {
          checkState: ''
      },
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          fixed: 'left',
          width: '90',
        },
        {
          title: "准考证号",
          prop: "entranceCode",
          width: "90",
          fixed: "left"
        },
        {
          title: "证件号",
          prop: "cardNo",
          width: "90",
          fixed: "left"
        },
        {
          title: "函授站",
          prop: "stationName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "分数",
          prop: "score",
          width: '60',
        },
        {
          title: "成绩",
          prop: "result",
          width: '90',
          // formatter: (val) => val.row.classSetStudent == 1 ? '已安排' : '未安排',
        },
        // {
        //     title:"签到状态",
        //     // prop: "placeNames",
        //     formatter: (val) => val.row.signState == 1 ? '已发布' : '未发布',
        // },
        {
          title: "人脸验证状态",
          prop: "photoCheckState",
          formatter: (val) => photoState[val.row.photoCheckState] || "",
        },
        {
          title: "人脸验证审核状态",
          prop: "humanAuditState",
          width: '90'
        },
        {
          title: "考试状态",
          prop: "checkState",
          width: '90',
        },
        {
          title: "发布状态",
          prop: "placeNames",
          fixed: "right",
          formatter: (val) => (val.row.scorePublish == 1 ? "已发布" : "未发布"),
        },
        {
          title: "作答详情",
          type: "button",
          prop: "studentCount",
          fixed: "right",
          width: '60',
          formatter: (val) => (val.row.checkState == '缺考' ? '' : '查看'),
          disableFn: (val) => (val.row.result == "-" || val.row.checkState == '缺考' ? true : false),
          click: this.goOTS,
        },
        {
          title: "操作",
          fixed: "right",
          type: "button",
          width: '90',
          formatter: (val) => (val.row.checkState == '缺考' ? '' : (val.row.checkState == '正常' || val.row.checkState == '' ? '设置异常' : '恢复正常')),
          disableFn: (val) => (val.row.checkState == "缺考" ? true : false),
          click: this.setCheckState,
        },
      ],
      tableData: [],
      tableOption: {
        multiple: true,
        selectTable: this.isDisabledMultiple
      },
      pagination: {
        total: 0,
      },
      stuListParams: {
        planId: "",
        page: 1,
        size: 10,
      },
      exportForm: {
        exportType: 1, //1 全部 2 查询结果数据 3选中数据
      },
      selectIds: [],
      /* *** 表格顶部按钮 *** */
      batchOperBtn: [
        {
          title: "批量设置异常",
          icon: "iconfont icon-bianji",
          click: this.setErrorList,
        },
      ],
      /* *** 批量设置异常 *** */
      batchSetError: false,
      /* *** 自定义字段相关配置 *** */
      customSearch: [],
    };
  },
  watch: {
    // 'stuSelectParams.placeId': function (val) {
    //     this.stuSelectParams.classId = ''
    //     this.selectList[1].data = this.selectList[0].data.filter(item => item.id == val)[0].placeClassList
    // }
  },
  created() {
    this.initData();
  },
  computed: {
    /************************************
     * @isUse_SetErrorList 表格按钮样式
     ************************************/
    isUse_SetErrorList(){
      let scorePublish = this.$route.query.scorePublish;
      if (scorePublish == 1) {
        return false;
      } 
      return true;
    },    
  },
  methods: {
    /***********************************
     * @setErrorList 批量设置异常(弹窗)
     ***********************************/
    setErrorList(){
      // 1. 成绩是否发布
      if (!this.isUse_SetErrorList) {
        this.$message.warning('成绩已发布，无法设置异常状态！');
        return false;
      }
      // 2. 是否勾选列表
      if (this.selectIds.length > 0) {
        // 3. 初始化数据
        for (let key in this.batchSignParams) {
          this.batchSignParams[key] = '';
        }
        // 4. 批量设置考生异常, 展示弹窗
        this.batchSetError = true;
      } else {
        this.$message.warning('请选择要设置的学生！');
        return false;
      }
    },

    /************************************
     * @setBatchSign 批量设置异常(确定)
     ************************************/
    batchSetSign(){
      // 1. 判断是否可以提交
      if (this.batchSignParams.examState == '') {
        this.$message.warning('请选择考试状态！')
        return
      };
      // 2. 配置参数
      this.batchSignParams.planId = this.$route.query.planId;
      this.batchSignParams.studentCourseIds = this.selectIds.join(',');
      let params = {...this.batchSignParams};

      // 3. 再次判断成绩是否发布
      let publicParams = {
        courseId: this.$route.query.courseId,
        type: 0
      }
      getPlanCoursePublishFn(publicParams).then( res => {
        if ( res.data[0].scorePublish == 0) {
          return batchHumanAudit(params);
        } else {
          this.$message.warning('考试成绩已发布，不能再设置考试状态！');
          this.batchSetError = false;
          return
        }
      }).then(res=>{
        if (res.code == 1) {
          this.$message.success('操作成功！');
          this.batchSetError = false;
          // 4. 刷新列表
          this.getStuList(true);
        }
      })
    },

    /************************************
     * @this table_表格列表多选是否禁用
     ***********************************/
    isDisabledMultiple (row) {
      let { checkState } = row;
      if (checkState == '正常' || checkState == '') {
        return true
      }
      return false
    },

    /************************************
     * @this table_表格选中事件
     ***********************************/
    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.studentCourseId);
      });
      this.selectIds = idList;
    },

    /************************************
     * @initData 初始化数据
     ***********************************/
    async initData() {
      const { planId, courseId } = this.$route.query;
      this.stuSelectParams.planId = planId;
      this.stuSelectParams.courseId = courseId;
      // 获取考试标记列表
      this.mixin_getSelectExamSign().then((data) => {
          this.examSignList = data.filter(item => item.name != '正常' && item.name != '缺考')
      })
      this.mixin_setUserExtInfo().then(res=>{
        res.data.map( item => {
          let TypeList = ['select', 'province', 'subject', 'nation', 'politicalStatus', 'level'];
          // queryCondition 是否设置为查询条件
          if (item.queryCondition == 1) {
            // 下拉列表类型
            if (TypeList.includes(item.type)) {
              if ( item.valueVo ) {
                  let search = {
                      title: item.displayName,
                      type: 'select',
                      requestKey: item.name,
                      label: 'name',
                      value: 'name',
                      data: [ { name: "全部" }, ...item.valueVo ],
                  };      
                  this.customSearch.push(search);                         
              }
            } else if (item.type == 'text') {
              let search = {
                  title: item.displayName,
                  type: 'input',
                  requestKey: item.name,
                  placeholder: '请输入',
              };
              this.customSearch.push(search);  
            } else if (item.type == 'provinceCity') {
              let search = {
                title: item.displayName,
                type: 'cascader',
                requestKey: item.name,
                label: 'name',
                value: 'name',
                data: [ { name: "全部" }, ...item.valueVo ],
              };  
              this.customSearch.push(search); 
            }
          } 
          // table 表格数据
          if (item.type == 'imageUpload') {
              let tables = {
                  title: item.displayName,
                  type: 'img',
                  width: "120",
                  prop: item.name,
              }
              this.tableHeader.push(tables);
          } else {
              let tables = {
                  title: item.displayName,
                  width: "120",
                  prop: item.name,
              }   
              this.tableHeader.push(tables);
          };
        })
        this.stuSelectParams = Object.assign(this.stuSelectParams, res.requestForm);
        this.selectList = [...this.selectList,...this.customSearch];
      })

      /* *** 查询自定字段中, 是否配置了层次 ** */
      // this.mixin_setUserExtInfo().then( res => {
      //     res.data.map( e => {
      //         // (1) 判断是否有层次, 是否设置了作为查询条件
      //         if (e.type == 'level' && e.queryCondition == 1) {
      //             this.stuSelectParams[e.name] = '';
      //             // (2) 配置 "层次" 下拉选项
      //             let Level = {
      //                 title: "层次",
      //                 type: "select",
      //                 requestKey: e.name,
      //                 label: "name",
      //                 value: "name",
      //                 data: [
      //                   {
      //                   name: "全部",
      //                   },
      //                   ...e.valueVo,
      //                 ]
      //             }
      //             // (3) 搜索表单添加层次
      //             this.selectList.push(Level);

      //             // (4) 配置表格层次列
      //             let tableLevel = {
      //               title: "层次",
      //               prop: e.name,
      //             }
                  
      //             // (5) 层次插入表格列
      //             this.tableHeader.splice(this.tableHeader.length - 2, 0, tableLevel);
      //         } else {
      //             return false;
      //         }
      //     })        
      // })

      this.getStuList();
    },

    /************************
     * @this 查询考生成绩
     ************************/
    async getStuList(page) {
      let params;
      if (!page) {
        this.stuListParams.page = 1;
        params = Object.assign(this.stuListParams, this.stuSelectParams);
      } else {
        params = Object.assign(this.stuTempParams, {
          page: this.stuListParams.page,
        });
      }
      /* *** 自定义字段 - 层次 - 选择 "全部" 时表单值置空 *** */
      for (let key in params) {
        params[key] = params[key] == "全部" ? '' : params[key];
      }
      const { data } = await getStudentScoreListFn(params);

      this.stuTempParams = params;
      this.tableData = data.records;
      this.totalText = data.totalShowText
      this.pagination.total = data.total;
      data.records.forEach((e) => {
        e.extData.forEach((item) => {
          e[item.name] = item.value;
        });
      });
    },
    
    async goOTS(row) {
      let params = {
        action: "getTReviewDetails",
        parames: `argumentsId=${row.recordId}&curPage=JudgeLib`,
      };
      const { code, data } = await getOtsUrlFn(params);
      if (code == 1) {
        window.open(data);
      }
    },
    setCheckState(val) {
      this.currentStudent = val
      const { checkState } = this.currentStudent
      if (checkState == '正常') {
        this.signDialog = true
      } else {
        this.$confirm('确认将学生考试状态恢复为正常？', '提示').then(() => {
          this.signParams.checkState = 1 // 正常状态为1
          this.setSign()
        }).catch(() => {})
      }
    },
    setSign() {
      if (this.signParams.checkState == '') {
        this.$message.warning('请选择考试状态！')
        return
      }
      const { studentCourseId } = this.currentStudent
      const params = { ...this.signParams, studentCourseId }
      changeExamCheckStateFn(params).then(res => {
        if (res.code == 1) {
          this.$message.success('操作成功')
          this.getStuList()
          this.signDialog = false
          // 重置状态
          this.signParams.checkState = ''
        }
      })
    },
    exportScore() {
      exportStudentScoreFn(this.stuSelectParams).then( res => {
        if (res.code == 1) {
          window.open(res.data);
        }
      }).catch( err => {
        this.$message.danger(err)
      })
    },
    changeSize(num) {
      this.stuListParams.size = num;
      this.getStuList();
    },
    changePage(p) {
      this.stuListParams.page = p;
      this.getStuList(true);
    },
  },
};
</script>
<style lang="less" scoped>
/* *** 表单 label 样式, 防止表单 label 过长 *** */
.searchBox /deep/ .el-form-item__label{
  min-width: 120px;
  width: auto!important;
}

/* *** 表格左上方按钮样式 *** */
.batchOperation {
  margin-bottom: 16px;
  ul {
    display: flex;
    li {
      a {
        border-radius: 20px;
        border: 1px solid #E1E6ED;
        padding: 8px 20px;
        display: block;
        margin-right: 24px;
        font-size: 14px;
        color: #006AFF;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}

/* *** 表格左上方按钮禁用样式 *** */
.batchOperationDis {
  margin-bottom: 16px;
  ul {
    display: flex;
    // 图标颜色
    .iconfont {
      color: #606266!important;
    }
    li {
      a {
        border-radius: 20px;
        border: 1px solid #E1E6ED;
        padding: 8px 20px;
        display: block;
        margin-right: 24px;
        font-size: 14px;
        color: #606266;
        cursor: not-allowed;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}

/* *** 弹窗 p 样式 *** */
.studentNumber {
  margin-bottom: 32px;
}



.topTip {
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #ebf0fa;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
}
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
.searchBox {
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}
</style>